import localizationData from "./mountain.en.json";
import localized from "model/events/util";

const events = (context, onDone) =>
  [
    {
      title: "event.mountainPass.title",
      baseWeight: 30,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainPass.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass.spring.night.description",
            effect: { calendar: { time: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainPass.summer.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass.summer.night.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainPass.autumn.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mountainPass.autumn.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainPass.winter.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass.winter.night.description",
            effect: { resources: { health: -15 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainPass.button.continue",
          message: "event.mountainPass.button.message.continue",
          effect: {},
        },
        {
          title: "event.mountainPass.button.setupCamp",
          message: "event.mountainPass.button.message.setupCamp",
          effect: { resources: { health: -5, morale: +2 } },
        },
      ],
    },
    {
      title: "event.unexpectedStorm.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.unexpectedStorm.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.unexpectedStorm.spring.night.description",
            effect: { calendar: { time: +2 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.unexpectedStorm.summer.day.description",
            effect: { resources: { health: +2 } },
            weightAdjustment: 3,
          },
          night: {
            description: "event.unexpectedStorm.summer.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 7,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.unexpectedStorm.autumn.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 7,
          },
          night: {
            description: "event.unexpectedStorm.autumn.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.unexpectedStorm.winter.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.unexpectedStorm.winter.night.description",
            effect: { resources: { health: -20 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.unexpectedStorm.button.seekShelter",
          message: "event.unexpectedStorm.button.message.seekShelter",
          effect: { resources: { morale: 5, health: -10 } },
        },
        {
          title: "event.unexpectedStorm.button.pressOn",
          message: "event.unexpectedStorm.button.message.pressOn",
          effect: { resources: { health: -5 } },
        },
      ],
    },
    {
      title: "event.mountainWildlife.title",
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainWildlife.spring.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainWildlife.spring.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainWildlife.summer.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mountainWildlife.summer.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainWildlife.autumn.day.description",
            effect: {},
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainWildlife.autumn.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainWildlife.winter.day.description",
            effect: {},
            weightAdjustment: 10,
          },
          night: {
            description: "event.mountainWildlife.winter.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainWildlife.button.observe",
          message: "event.mountainWildlife.button.message.observe",
          effect: { resources: { morale: +5 } },
        },
        {
          title: "event.mountainWildlife.button.avoid",
          message: "event.mountainWildlife.button.message.avoid",
          effect: { resources: { health: 5 } },
        },
      ],
    },
    {
      title: "event.abandonedShelter.title",
      baseWeight: 20,
      variants: [
        {
          season: ["spring", "summer", "autumn"],
          day: {
            description: "event.abandonedShelter.nonWinter.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.abandonedShelter.nonWinter.night.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.abandonedShelter.winter.day.description",
            effect: { resources: { health: +15 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.abandonedShelter.winter.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.abandonedShelter.button.rest",
          message: "event.abandonedShelter.button.message.rest",
          effect: { resources: { health: +10, morale: +5 } },
        },
        {
          title: "event.abandonedShelter.button.explore",
          message: "event.abandonedShelter.button.message.explore",
          effect: { resources: { ammo: +5, coins: +10 } },
        },
        {
          title: "event.abandonedShelter.button.continue",
          message: "event.abandonedShelter.button.message.continue",
          effect: {},
        },
      ],
    },
    {
      title: "event.ascentBegins.title",
      baseWeight: 30,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.ascentBegins.spring.day.description",
            effect: { resources: { morale: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.ascentBegins.spring.night.description",
            effect: { calendar: { time: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.ascentBegins.summer.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.ascentBegins.summer.night.description",
            effect: { resources: { morale: +5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.ascentBegins.autumn.day.description",
            effect: { resources: { health: +5, morale: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.ascentBegins.autumn.night.description",
            effect: { calendar: { time: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.ascentBegins.winter.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.ascentBegins.winter.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.ascentBegins.button.beginTheAscent",
          message: "event.ascentBegins.button.message.beginTheAscent",
        },
      ],
    },
    {
      title: "event.icyPathChallenge.title",
      baseWeight: 10,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.icyPathChallenge.winter.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.icyPathChallenge.winter.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 15,
          },
        },
        {
          season: ["spring", "summer", "autumn"],
          day: {
            description: "event.icyPathChallenge.nonWinter.day.description",
            effect: {},
            weightAdjustment: -5,
          },
          night: {
            description: "event.icyPathChallenge.nonWinter.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.icyPathChallenge.button.treadCarefully",
          message: "event.icyPathChallenge.button.message.treadCarefully",
          effect: { resources: { health: -5 } },
        },
        {
          title: "event.icyPathChallenge.button.findAnotherRoute",
          message: "event.icyPathChallenge.button.message.findAnotherRoute",
          effect: { resources: { health: -10 }, traits: { resilience: 1 } },
        },
      ],
    },
    {
      title: "event.mountainSpringEncounter.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainSpringEncounter.spring.day.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description:
              "event.mountainSpringEncounter.spring.night.description",
            effect: { resources: { morale: +5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainSpringEncounter.summer.day.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: -5,
          },
          night: {
            description:
              "event.mountainSpringEncounter.summer.night.description",
            effect: { resources: { morale: +5 } },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainSpringEncounter.button.refillWater",
          message: "event.mountainSpringEncounter.button.message.refillWater",
          effect: { resources: { water: +20 } },
        },
        {
          title: "event.mountainSpringEncounter.button.observeWildlife",
          message:
            "event.mountainSpringEncounter.button.message.observeWildlife",
          effect: { resources: { morale: +5 } },
        },
        {
          title: "event.mountainSpringEncounter.button.continue",
          message: "event.mountainSpringEncounter.button.message.continue",
          effect: {},
        },
      ],
    },
    {
      title: "event.frostbite.title",
      baseWeight: 20,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.frostbite.winter.day.description",
            effect: {
              resources: { health: -10 },
              traits: { resilience: -1 },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.frostbite.winter.night.description",
            effect: {
              resources: { health: -15 },
              traits: { resilience: -1 },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.frostbite.autumn.day.description",
            effect: {
              resources: { health: -5 },
              traits: { resilience: -1 },
            },
            weightAdjustment: -5,
          },
          night: {
            description: "event.frostbite.autumn.night.description",
            effect: {
              resources: { health: -10 },
              traits: { dexterity: -1 },
            },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.frostbite.button.lose",
          message: "event.frostbite.button.message.lose",
          effect: { resources: { health: -10 } },
        },
        {
          title: "event.frostbite.button.seekTreatment",
          message: "event.frostbite.button.message.seekTreatment",
          effect: { resources: { morale: -5 } },
        },
      ],
    },
    {
      title: "event.bountyOfTheValley.title",
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bountyOfTheValley.spring.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bountyOfTheValley.spring.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bountyOfTheValley.summer.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.bountyOfTheValley.summer.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bountyOfTheValley.autumn.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bountyOfTheValley.autumn.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bountyOfTheValley.winter.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.bountyOfTheValley.winter.night.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.bountyOfTheValley.button.gatherHerbs",
          message: "event.bountyOfTheValley.button.message.gatherHerbs",
        },
        {
          title: "event.bountyOfTheValley.button.leaveHerbs",
          message: "event.bountyOfTheValley.button.message.leaveHerbs",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.predatorsDesperation.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.predatorsDesperation.spring.day.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["bear"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.predatorsDesperation.spring.night.description",
            effect: { resources: { ammo: -10 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.predatorsDesperation.summer.day.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.predatorsDesperation.summer.night.description",
            effect: { resources: { ammo: -10 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.predatorsDesperation.autumn.day.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.predatorsDesperation.autumn.night.description",
            effect: { resources: { ammo: -10 } },
            enemies: ["bear"],
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.predatorsDesperation.winter.day.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: 5,
          },
          night: {
            description: "event.predatorsDesperation.winter.night.description",
            effect: { resources: { ammo: -15 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.predatorsDesperation.button.defend",
          combat: {
            description: "event.predatorsDesperation.button.defend.description",
            victory: "event.predatorsDesperation.button.defend.victory",
            defeat: "event.predatorsDesperation.button.defend.defeat",
          },
        },
        {
          title: "event.predatorsDesperation.button.evade",
          message: "event.predatorsDesperation.button.message.evade",
        },
      ],
    },
    {
      title: "event.mountainSprings.title",
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainSprings.spring.day.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainSprings.spring.night.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainSprings.summer.day.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainSprings.summer.night.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainSprings.autumn.day.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainSprings.autumn.night.description",
            effect: { resources: { water: +20 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainSprings.winter.day.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.mountainSprings.winter.night.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: -10,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainSprings.button.refillWater",
          message: "event.mountainSprings.button.message.refillWater",
        },
        {
          title: "event.mountainSprings.button.continue",
          message: "event.mountainSprings.button.message.continue",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.mountainsFury.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainsFury.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainsFury.spring.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainsFury.summer.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsFury.summer.night.description",
            effect: { resources: { health: -15 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainsFury.autumn.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsFury.autumn.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainsFury.winter.day.description",
            effect: { resources: { health: -20 } },
            weightAdjustment: 15,
          },
          night: {
            description: "event.mountainsFury.winter.night.description",
            effect: { resources: { health: -25 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainsFury.button.evadeDanger",
          message: "event.mountainsFury.button.message.evadeDanger",
          effect: { resources: { health: -5 } },
        },
        {
          title: "event.mountainsFury.button.proceedWithCaution",
          message: "event.mountainsFury.button.message.proceedWithCaution",
          effect: { resources: { health: -10 }, traits: { resilience: 1 } },
        },
      ],
    },
    {
      title: "event.encampmentSolace.title",
      baseWeight: 30,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.encampmentSolace.spring.day.description",
          },
          night: {
            description: "event.encampmentSolace.spring.night.description",
          },
        },
        {
          season: "summer",
          day: {
            description: "event.encampmentSolace.summer.day.description",
            weightAdjustment: 5,
          },
          night: {
            description: "event.encampmentSolace.summer.night.description",
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.encampmentSolace.autumn.day.description",
          },
          night: {
            description: "event.encampmentSolace.autumn.night.description",
          },
        },
        {
          season: "winter",
          day: {
            description: "event.encampmentSolace.winter.day.description",
            weightAdjustment: -5,
          },
          night: {
            description: "event.encampmentSolace.winter.night.description",
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.encampmentSolace.button.trade",
          message: "event.encampmentSolace.button.message.trade",
          effect: { resources: { coins: -10, food: 10, water: 10, ammo: 10 } },
        },
        {
          title: "event.encampmentSolace.button.rest",
          message: "event.encampmentSolace.button.message.rest",
          effect: { resources: { health: +10, coins: -5 } },
        },
        {
          title: "event.encampmentSolace.button.moveOn",
          message: "event.encampmentSolace.button.message.moveOn",
        },
      ],
    },
    {
      title: "event.theThirstOfCanyons.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.theThirstOfCanyons.spring.day.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.theThirstOfCanyons.spring.night.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.theThirstOfCanyons.summer.day.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.theThirstOfCanyons.summer.night.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.theThirstOfCanyons.autumn.day.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.theThirstOfCanyons.autumn.night.description",
            effect: { resources: { water: -10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.theThirstOfCanyons.winter.day.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.theThirstOfCanyons.winter.night.description",
            effect: { resources: { water: -5 } },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.theThirstOfCanyons.conserve",
          message: "event.theThirstOfCanyons.conserve.message",
          effect: { resources: { water: -5 } },
        },
        {
          title: "event.theThirstOfCanyons.search",
          message: "event.theThirstOfCanyons.search.message",
          effect: { resources: { water: 10 } },
        },
      ],
    },
    {
      title: "event.legacyLost.title",
      baseWeight: 15,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.legacyLost.spring.day.description",
            effect: { resources: { ammo: +10, coins: +20 } },
            weightAdjustment: +5,
          },
          night: {
            description: "event.legacyLost.spring.night.description",
            effect: { resources: { ammo: +10, coins: +20 } },
            weightAdjustment: +5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.legacyLost.summer.day.description",
            effect: { resources: { ammo: +15, coins: +30 } },
            weightAdjustment: +10,
          },
          night: {
            description: "event.legacyLost.summer.night.description",
            effect: { resources: { ammo: +15, coins: +30 } },
            weightAdjustment: +10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.legacyLost.autumn.day.description",
            effect: { resources: { ammo: +20, coins: +40 } },
            weightAdjustment: +0,
          },
          night: {
            description: "event.legacyLost.autumn.night.description",
            effect: { resources: { ammo: +20, coins: +40 } },
            weightAdjustment: +0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.legacyLost.winter.day.description",
            effect: { resources: { ammo: +20, coins: +40 } },
            weightAdjustment: +0,
          },
          night: {
            description: "event.legacyLost.winter.night.description",
            effect: { resources: { ammo: +20, coins: +40 } },
            weightAdjustment: +0,
          },
        },
      ],
      buttons: [
        {
          title: "event.legacyLost.salvageSupplies",
          message: "event.legacyLost.salvageSupplies.message",
        },
        {
          title: "event.legacyLost.moveOn",
          message: "event.legacyLost.moveOn.message",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.naturesFuryUnleashed.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.naturesFuryUnleashed.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.naturesFuryUnleashed.spring.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.naturesFuryUnleashed.summer.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.naturesFuryUnleashed.summer.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.naturesFuryUnleashed.autumn.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.naturesFuryUnleashed.autumn.night.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.naturesFuryUnleashed.winter.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.naturesFuryUnleashed.winter.night.description",
            effect: { resources: { health: -15 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.naturesFuryUnleashed.button.pressOn",
          message: "event.naturesFuryUnleashed.button.message.pressOn",
          effect: { resources: { health: -5 } },
        },
        {
          title: "event.naturesFuryUnleashed.button.seekShelter",
          message: "event.naturesFuryUnleashed.button.message.seekShelter",
          effect: { resources: { health: -10, morale: 5 } },
        },
      ],
    },
    {
      title: "event.beyondThePeaks.title",
      baseWeight: 25,
      isLeaving: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.beyondThePeaks.spring.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.beyondThePeaks.spring.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.beyondThePeaks.summer.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.beyondThePeaks.summer.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.beyondThePeaks.autumn.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.beyondThePeaks.autumn.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.beyondThePeaks.winter.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.beyondThePeaks.winter.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.beyondThePeaks.button.continue",
          message: "event.beyondThePeaks.button.message.continue",
        },
      ],
    },
    {
      title: "event.mountainsLoomAhead.title",
      baseWeight: 100,
      isEntering: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainsLoomAhead.spring.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsLoomAhead.spring.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainsLoomAhead.summer.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsLoomAhead.summer.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainsLoomAhead.autumn.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsLoomAhead.autumn.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainsLoomAhead.winter.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainsLoomAhead.winter.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainsLoomAhead.button.difficultClimb",
          message: "event.mountainsLoomAhead.button.message.difficultClimb",
          effect: { resources: { health: -10, morale: 1 } },
        },
        {
          title: "event.mountainsLoomAhead.button.slowerPath",
          message: "event.mountainsLoomAhead.button.message.slowerPath",
          effect: { calendar: { morale: -3 } },
        },
      ],
    },
    {
      title: "event.clawingCold.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          description: "event.clawingCold.spring.description",
          effect: {
            resources: { health: -5 },
            traits: { resilience: -1 },
          },
          weightAdjustment: -5,
        },
        {
          season: "summer",
          description: "event.clawingCold.summer.description",
          effect: {
            resources: { health: -5 },
            traits: { resilience: -1 },
          },
          weightAdjustment: -10,
        },
        {
          season: "autumn",
          description: "event.clawingCold.autumn.description",
          effect: {
            resources: { health: -7 },
            traits: { resilience: -1 },
          },
          weightAdjustment: -5,
        },
        {
          season: "winter",
          description: "event.clawingCold.winter.description",
          effect: {
            resources: { health: -10 },
            traits: { resilience: -1 },
          },
          weightAdjustment: 0,
        },
      ],
      buttons: [
        {
          title: "event.clawingCold.button.seekMedicalAid",
          message: "event.clawingCold.button.message.seekMedicalAid",
          effect: { resources: { morale: -5, health: 5 } },
        },
        {
          title: "event.clawingCold.button.endurePain",
          message: "event.clawingCold.button.message.endurePain",
        },
      ],
    },

    {
      title: "event.mountainPass2.title",
      isBuild: true,
      baseWeight: 30,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.mountainPass2.winter.day.description",
            effect: { resources: { health: -10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass2.winter.night.description",
            effect: { resources: { health: -15 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "spring",
          day: {
            description: "event.mountainPass2.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass2.spring.night.description",
            effect: { calendar: { time: +1 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainPass2.summer.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainPass2.summer.night.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainPass2.autumn.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mountainPass2.autumn.night.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 5,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainPass2.button.pressOn",
          message: "event.mountainPass2.button.message.pressOn",
          effect: { resources: { health: -5 } },
        },
        {
          title: "event.mountainPass2.button.seekShelter",
          message: "event.mountainPass2.button.message.seekShelter",
          effect: { resources: { health: -10, morale: 5 } },
        },
      ],
    },
    {
      title: "event.hiddenCave.title",
      baseWeight: 30,
      variants: [
        {
          day: {
            description: "event.hiddenCave.day.description",
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.hiddenCave.night.description",
            effect: {},
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.hiddenCave.button.investigate",
          message: "event.hiddenCave.button.message.investigate",
          effect: { resources: { health: +10, food: +10, water: +10 } },
        },
        {
          title: "event.hiddenCave.button.continue",
          message: "event.hiddenCave.button.message.continue",
          effect: {},
        },
      ],
    },
    {
      title: "event.animalTracks.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          day: {
            description: "event.animalTracks.day.description",
            enemies: ["cougar"],
            effect: {},
            weightAdjustment: 0,
          },
          night: {
            description: "event.animalTracks.night.description",
            enemies: ["cougar"],
            effect: {},
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.animalTracks.button.investigate",
          combat: {
            description: "event.animalTracks.button.investigate.description",
            victory: "event.animalTracks.button.investigate.victory",
            defeat: "event.animalTracks.button.investigate.defeat",
          },
        },
        {
          title: "event.animalTracks.button.steerClear",
          message: "event.animalTracks.button.message.steerClear",
        },
      ],
    },
    {
      title: "event.lost.title",
      baseWeight: 10,
      variants: [
        {
          description: "event.lost.description",
          effect: {},
        },
      ],
      buttons: [
        {
          title: "event.lost.button.navigate",
          message: "event.lost.button.message.navigate",
          effect: { resources: { health: -5, food: -10 } },
        },
        {
          title: "event.lost.button.wait",
          message: "event.lost.button.message.wait",
          effect: { resources: { morale: -5 } },
        },
      ],
    },
    {
      title: "event.strangeLights.title",
      baseWeight: 15,
      isCombat: true,
      variants: [
        {
          description: "event.strangeLights.description",
          effect: {},
        },
      ],
      buttons: [
        {
          title: "event.strangeLights.button.investigate",
          combat: {
            enemies: ["outlaw", "outlaw", "outlaw"],
            description: "event.strangeLights.button.investigate.description",
            victory: "event.strangeLights.button.investigate.victory",
            defeat: "event.strangeLights.button.investigate.defeat",
          },
        },
        {
          title: "event.strangeLights.button.ignore",
          message: "event.strangeLights.button.message.ignore",
        },
      ],
    },
    {
      title: "event.injuredClimber.title",
      baseWeight: 20,
      variants: [
        {
          description: "event.injuredClimber.description",
        },
      ],
      buttons: [
        {
          title: "event.injuredClimber.button.help",
          message: "event.injuredClimber.button.message.help",
          effect: {
            resources: { food: -10, water: -10 },
            traits: { infamy: -1, charisma: +1 },
          },
        },
        {
          title: "event.injuredClimber.button.moveOn",
          message: "event.injuredClimber.button.message.moveOn",
          effect: {
            traits: { infamy: +1, charisma: -1 },
          },
        },
      ],
    },
    {
      title: "event.avalanche.title",
      baseWeight: 20,
      isBuild: true,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.avalanche.day.description",
            effect: {},
          },
          night: {
            description: "event.avalanche.night.description",
            effect: {},
          },
        },
      ],
      buttons: [
        {
          title: "event.avalanche.button.run",
          message: "event.avalanche.button.message.run",
          effect: { resources: { health: -10, food: -10, water: -10 } },
        },
        {
          title: "event.avalanche.button.seekShelter",
          message: "event.avalanche.button.message.seekShelter",
          effect: { resources: { health: -15, morale: 5 } },
        },
      ],
    },
    {
      title: "event.blizzard.title",
      baseWeight: 30,
      isBuild: true,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.blizzard.winter.day.description",
            effect: {
              resources: {
                health: -15,
              },
              traits: {
                resilience: -1,
              },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.blizzard.winter.night.description",
            effect: {
              resources: {
                health: -20,
              },
              traits: {
                resilience: -1,
              },
            },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.blizzard.button.seekShelter",
          message: "event.blizzard.button.message.seekShelter",
          effect: { traits: { resilience: +1 }, resources: { health: -10 } },
        },
        {
          title: "event.blizzard.button.pressOn",
          message: "event.blizzard.button.message.pressOn",
          effect: { resources: { health: -5, morale: 5 } },
        },
      ],
    },
    {
      title: "event.unexpectedEncounter.title",
      baseWeight: 10,
      description: "event.unexpectedEncounter.description",
      buttons: [
        {
          title: "event.unexpectedEncounter.button.engage",
          message: "event.unexpectedEncounter.button.message.engage",
          effect: { resources: { morale: +1 } },
        },
        {
          title: "event.unexpectedEncounter.button.passBy",
          message: "event.unexpectedEncounter.button.message.passBy",
          effect: { resources: { morale: -1 } },
        },
      ],
    },
    {
      title: "event.patchOfPlenty.title",
      baseWeight: 15,
      variants: [
        {
          season: "spring",
          description: "event.patchOfPlenty.spring.description",
          effect: { resources: { health: +10, food: +10 } },
        },
        {
          season: "summer",
          description: "event.patchOfPlenty.summer.description",
          effect: { resources: { health: +10, food: +15 } },
        },
        {
          season: "autum",
          description: "event.patchOfPlenty.autumn.description",
          effect: { resources: { health: +10, food: +20 } },
        },
      ],
      buttons: [
        {
          title: "event.patchOfPlenty.button.harvest",
          message: "event.patchOfPlenty.button.message.harvest",
          effect: { resources: { health: +5 } },
        },
        {
          title: "event.patchOfPlenty.button.moveOn",
          message: "event.patchOfPlenty.button.message.moveOn",
          effect: {},
        },
      ],
    },
    {
      title: "event.runningLow.title",
      baseWeight: 25,
      description: "event.runningLow.description",
      buttons: [
        {
          title: "event.runningLow.button.conserve",
          message: "event.runningLow.button.message.conserve",
          effect: { resources: { morale: -10 } },
        },
        {
          title: "event.runningLow.button.searchForMore",
          message: "event.runningLow.button.message.searchForMore",
          effect: { resources: { food: +10, water: +10 }, health: -10 },
        },
      ],
    },
    {
      title: "event.hungryShadows.title",
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.hungryShadows.spring.day.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["bear"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.hungryShadows.spring.night.description",
            effect: { resources: { ammo: -7 } },
            enemies: ["bear"],
            weightAdjustment: 0,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.hungryShadows.summer.day.description",
            effect: { resources: { ammo: -3 } },
            enemies: ["snake"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.hungryShadows.summer.night.description",
            effect: { resources: { ammo: -5 } },
            enemies: ["cougar"],
            weightAdjustment: 0,
          },
        },
        {
          season: "autum",
          day: {
            description: "event.hungryShadows.autumn.day.description",
            effect: { resources: { ammo: -1 } },
            enemies: ["cougar"],
            weightAdjustment: -10,
          },
          night: {
            description: "event.hungryShadows.autumn.night.description",
            effect: { resources: { ammo: -7 } },
            enemies: ["cougar"],
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.hungryShadows.winter.day.description",
            effect: { resources: { ammo: -15 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: +5,
          },
          night: {
            description: "event.hungryShadows.winter.night.description",
            effect: { resources: { ammo: -20 } },
            enemies: ["wolf", "wolf", "wolf", "wolf"],
            weightAdjustment: +10,
          },
        },
      ],
      buttons: [
        {
          title: "event.hungryShadows.button.defendSupplies",
          combat: {
            description:
              "event.hungryShadows.button.defendSupplies.description",
            victory: "event.hungryShadows.button.defendSupplies.victory",
            defeat: "event.hungryShadows.button.defendSupplies.defeat",
          },
        },
        {
          title: "event.hungryShadows.button.flee",
          message: "event.hungryShadows.button.message.flee",
          effect: {
            resources: { ammo: -10, food: -10, water: -10, health: -5 },
          },
        },
      ],
    },
    {
      title: "event.crystalBounty.title",
      baseWeight: 15,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.crystalBounty.spring.day.description",
            effect: { resources: { water: +20 } },
          },
          night: {
            description: "event.crystalBounty.spring.night.description",
            effect: { resources: { water: +15 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.crystalBounty.summer.day.description",
            effect: { resources: { water: +25 } },
          },
          night: {
            description: "event.crystalBounty.summer.night.description",
            effect: { resources: { water: +20 } },
          },
        },
        {
          season: "autum",
          day: {
            description: "event.crystalBounty.autumn.day.description",
            effect: { resources: { water: +15 } },
          },
          night: {
            description: "event.crystalBounty.autumn.night.description",
            effect: { resources: { water: +10 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.crystalBounty.winter.day.description",
            effect: { resources: { water: +10 } },
          },
          night: {
            description: "event.crystalBounty.winter.night.description",
            effect: { resources: { water: +5 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.crystalBounty.button.gatherWater",
          message: "event.crystalBounty.button.message.gatherWater",
        },
        {
          title: "event.crystalBounty.button.continueOn",
          message: "event.crystalBounty.button.message.continueOn",
          effect: { resources: { water: -20 } },
        },
      ],
    },
    {
      title: "event.mountainHospitality.title",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainHospitality.spring.day.description",
            effect: { resources: { coins: +40 } },
          },
          night: {
            description: "event.mountainHospitality.spring.night.description",
            effect: { resources: { coins: +30 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainHospitality.summer.day.description",
            effect: { resources: { coins: +50 } },
          },
          night: {
            description: "event.mountainHospitality.summer.night.description",
            effect: { resources: { coins: +35 } },
          },
        },
        {
          season: "autum",
          day: {
            description: "event.mountainHospitality.autumn.day.description",
            effect: { resources: { coins: +45 } },
          },
          night: {
            description: "event.mountainHospitality.autumn.night.description",
            effect: { resources: { coins: +30 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainHospitality.winter.day.description",
            effect: { resources: { coins: +25 } },
          },
          night: {
            description: "event.mountainHospitality.winter.night.description",
            effect: { resources: { coins: +20 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainHospitality.button.tradeGoods",
          message: "event.mountainHospitality.button.message.tradeGoods",
          effect: {},
        },
        {
          title: "event.mountainHospitality.button.continueOn",
          message: "event.mountainHospitality.button.message.continueOn",
          isReject: true,
        },
      ],
    },
    {
      title: "event.gripOfDrought.title",
      baseWeight: 25,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.gripOfDrought.spring.day.description",
            effect: { resources: { water: -5 } },
          },
          night: {
            description: "event.gripOfDrought.spring.night.description",
            effect: { resources: { water: -3 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.gripOfDrought.summer.day.description",
            effect: { resources: { water: -15 } },
          },
          night: {
            description: "event.gripOfDrought.summer.night.description",
            effect: { resources: { water: -10 } },
          },
        },
        {
          season: "autum",
          day: {
            description: "event.gripOfDrought.autumn.day.description",
            effect: { resources: { water: -7 } },
          },
          night: {
            description: "event.gripOfDrought.autumn.night.description",
            effect: { resources: { water: -5 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.gripOfDrought.winter.day.description",
            effect: { resources: { water: -8 } },
          },
          night: {
            description: "event.gripOfDrought.winter.night.description",
            effect: { resources: { water: -10 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.gripOfDrought.button.seekWater",
          message: "event.gripOfDrought.button.message.seekWater",
          effect: { resources: { water: +15, health: -5 } },
        },
        {
          title: "event.gripOfDrought.button.pressOn",
          message: "event.gripOfDrought.button.message.pressOn",
          effect: {},
        },
      ],
    },
    {
      title: "event.spoilsOfTheStorm.title",
      baseWeight: 10,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.spoilsOfTheStorm.spring.day.description",
            effect: { resources: { ammo: 5, coins: 10 } },
          },
          night: {
            description: "event.spoilsOfTheStorm.spring.night.description",
            effect: { resources: { ammo: 10, coins: 15 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.spoilsOfTheStorm.summer.day.description",
            effect: { resources: { ammo: 20, coins: 40 } },
          },
          night: {
            description: "event.spoilsOfTheStorm.summer.night.description",
            effect: { resources: { ammo: 15, coins: 30 } },
          },
        },
        {
          season: "autum",
          day: {
            description: "event.spoilsOfTheStorm.autumn.day.description",
            effect: { resources: { ammo: 10, coins: 20 } },
          },
          night: {
            description: "event.spoilsOfTheStorm.autumn.night.description",
            effect: { resources: { ammo: 15, coins: 25 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.spoilsOfTheStorm.winter.day.description",
            effect: { resources: { ammo: 20, coins: 40 } },
          },
          night: {
            description: "event.spoilsOfTheStorm.winter.night.description",
            effect: { resources: { ammo: 25, coins: 50 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.spoilsOfTheStorm.button.searchForSupplies",
          message: "event.spoilsOfTheStorm.button.message.searchForSupplies",
          effect: { resources: { ammo: 5, coins: 10 } },
        },
        {
          title: "event.spoilsOfTheStorm.button.continueOn",
          message: "event.spoilsOfTheStorm.button.message.continueOn",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.ensnaredByTheBlizzard.title",
      baseWeight: 30,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.ensnaredByTheBlizzard.spring.day.description",
            effect: { resources: { health: -5 } },
          },
          night: {
            description: "event.ensnaredByTheBlizzard.spring.night.description",
            effect: { resources: { health: -7 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.ensnaredByTheBlizzard.summer.day.description",
            effect: { resources: { health: -3 } },
          },
          night: {
            description: "event.ensnaredByTheBlizzard.summer.night.description",
            effect: { resources: { health: -5 } },
          },
        },
        {
          season: "autum",
          day: {
            description: "event.ensnaredByTheBlizzard.autumn.day.description",
            effect: { resources: { health: -8 } },
          },
          night: {
            description: "event.ensnaredByTheBlizzard.autumn.night.description",
            effect: { resources: { health: -10 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.ensnaredByTheBlizzard.winter.day.description",
            effect: { resources: { health: -10 } },
          },
          night: {
            description: "event.ensnaredByTheBlizzard.winter.night.description",
            effect: { resources: { health: -15 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.ensnaredByTheBlizzard.button.digOut",
          message: "event.ensnaredByTheBlizzard.button.message.digOut",
          effect: { resources: { health: -5 } },
        },
        {
          title: "event.ensnaredByTheBlizzard.button.seekShelter",
          message: "event.ensnaredByTheBlizzard.button.message.seekShelter",
          effect: { resources: { health: -10, morale: 5 } },
        },
      ],
    },

    {
      title: "event.verdantExpanse.title",
      isLeaving: true,
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          description: "event.verdantExpanse.spring.description",
          buttons: [
            {
              title: "event.verdantExpanse.button.continueJourney",
              message: "event.verdantExpanse.button.message.continueJourney",
              effect: { resources: { morale: +1 } },
            },
            {
              title: "event.verdantExpanse.button.exploreSpringMeadow",
              message:
                "event.verdantExpanse.button.message.exploreSpringMeadow",
              effect: { resources: { health: +5 } },
            },
          ],
        },
        {
          season: "summer",
          description: "event.verdantExpanse.summer.description",
          effect: { resources: { water: -5 } },
          weightAdjustment: -2,
          buttons: [
            {
              title: "event.verdantExpanse.button.searchForWater",
              message: "event.verdantExpanse.button.message.searchForWater",
              effect: { resources: { water: +5 } },
            },
            {
              title: "event.verdantExpanse.button.continue",
              message: "event.verdantExpanse.button.message.continue",
              effect: {},
            },
          ],
        },
        {
          season: "autum",
          description: "event.verdantExpanse.autumn.description",
          buttons: [
            {
              title: "event.verdantExpanse.button.continue",
              message: "event.verdantExpanse.button.message.continue",
              effect: {},
            },
            {
              title: "event.verdantExpanse.button.hunt",
              message: "event.verdantExpanse.button.message.hunt",
              effect: { resources: { food: +5 } },
            },
          ],
        },
        {
          season: "winter",
          description: "event.verdantExpanse.winter.description",
          effect: { resources: { health: -3 } },
          weightAdjustment: +3,
          buttons: [
            {
              title: "event.verdantExpanse.button.continue",
              message: "event.verdantExpanse.button.message.continue",
              effect: {},
            },
            {
              title: "event.verdantExpanse.button.followTracks",
              message: "event.verdantExpanse.button.message.followTracks",
              effect: { resources: { food: +5 } },
            },
          ],
        },
      ],
    },
    {
      title: "event.mountainAmbush.title",
      baseWeight: 30,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mountainAmbush.spring.day.description",
            effect: { resources: { health: -5, ammo: -3 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.mountainAmbush.spring.night.description",
            effect: {
              resources: { morale: -2 },
              traits: { stealth: -1 },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mountainAmbush.summer.day.description",
            effect: { resources: { water: -2 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.mountainAmbush.summer.night.description",
            effect: { traits: { luck: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mountainAmbush.autumn.day.description",
            effect: { resources: { food: -4 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.mountainAmbush.autumn.night.description",
            effect: {
              resources: { health: -7 },
              traits: { resilience: +1 },
            },
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mountainAmbush.winter.day.description",
            effect: { resources: { ammo: -4, food: +5 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.mountainAmbush.winter.night.description",
            effect: {
              resources: { coins: -5 },
              traits: { charisma: -1 },
            },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.mountainAmbush.button.fight",
          combat: {
            description: "event.mountainAmbush.button.fight.description",
            victory: "event.mountainAmbush.button.fight.victory",
            defeat: "event.mountainAmbush.button.fight.defeat",
            enemies: ["bandit", "bandit", "raider"],
          },
        },
        {
          title: "event.mountainAmbush.button.evade",
          message: "event.mountainAmbush.button.message.evade",
          effect: {},
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
